<template>
    <v-container fluid>
        <div v-if="!dataLoading">
            <v-row>
                <v-col>
                    <h4 class="text-h4">Edit Purchase Order #{{data.code}}</h4>
                    <p class="text-subtitle-1">Modify Purchase Order</p>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row justify="end">
                <v-col cols="12" md="3">
                    <v-btn
                        @click="exchangeRateIndexShown = true"
                        block
                        color="primary">
                        <v-icon left>mdi-chart-areaspline-variant</v-icon>
                        currency exchange
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <PurchaseOrderForm
                        ref="orderform"
                        v-model="data"
                        v-if="!PurcahseOrderLoading"
                        :exchange-rate-index-shown.sync="exchangeRateIndexShown"
                        />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="3">
                    <v-btn class="primary" block @click="handleSave" :loading="loading">
                        <v-icon left>mdi-content-save</v-icon>
                        save
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" @click="handleDiscard">
                    <v-btn block depressed >
                        <v-icon left>mdi-cancel</v-icon>
                        cancel
                    </v-btn>
                </v-col>
                <v-col cols="12" md="3" v-if="hasPermission(perm.purchase_order.delete)">
                    <v-btn depressed color="error" text block  @click="handleRemove" :loading="deleteLoading">
                        <v-icon left>mdi-delete</v-icon>
                        delete
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <div v-else>
            <v-row>
                <v-col>
                    <v-skeleton-loader type="heading" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-divider></v-divider>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                    <v-skeleton-loader type="text" class="my-4"/>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
                <v-col cols="12" md="6">
                    <v-skeleton-loader type="text" class="my-2"/>
                    <v-skeleton-loader type="text" class="my-2"/>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="d-flex">
                    <v-skeleton-loader type="button" class="my-4 me-4"/>
                    <v-skeleton-loader type="button" class="my-4"/>
                </v-col>
            </v-row>
        </div>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PurchaseOrderForm from "./../../components/purchase/PurchaseOrderForm"
import PAlert from './../../components/common/PAlert';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: "PurchaseOrderEditView",
    components: {
        PurchaseOrderForm,
        PAlert,
    },
    data() {
        return {
            id: null,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
            data: null,
            loading: false,
            dataLoading: false,
            deleteLoading: false,
            perm: permissions,
            exchangeRateIndexShown: false
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            findByID: "purchase/order/findByID",
            snackbar: "ui/snackbar/show",
            pushSupplier: "purchase/supplier/push",
            pushWarehouse: "purchase/warehouse/push",
            pushCurrency: "purchase/currency/push",
            pushItem: "purchase/item/push",
            update: "purchase/order/update",
            remove: "purchase/order/remove",
        }),
        handleNewLine() {
            this.$refs.orderform.addLine()
        },
        handleSave() {
            this.alert = {...this.alert, content: "Are you sure you want to save?", value: true, callback: this.save }
        },
        save() {
            if(!this.$refs.orderform.validate()) return;
            this.loading = true;
            this.update(this.data).then(response => {
                this.$router.push({name: "PurchaseOrderDisplay", params: {id: response.data.id}})
                this.snackbar({text: "Purcahse Order Updated", color: "success"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({text: message, color: "error"})
            }).finally(() => {
                this.loading = false
            });
        },
        handleRemove() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to delete Purchase Order?", callback: this.removePurchaseOrder}
        },
        removePurchaseOrder() {
            this.deleteLoading = true;
            this.remove(this.data).then(response => {
                console.log(response)
                this.snackbar({color: "success", text: "Purchase Order Deleted."});
                this.$router.push({name: "PurchaseOrderList"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({color: "error", text: message});
            }).finally(() => {
                this.dataLoading = false;
            })
        },
        formatData(data) {
            this.pushSupplier(data.supplier);
            this.pushWarehouse(data.warehouse);
            this.pushCurrency(data.currency);
            return {
                ...data,
                warehouse_id: data.warehouse.id,
                supplier_id: data.supplier.id,
                currency_id: data.currency.id,
                lines: data.lines.map(line => {
                    this.pushItem(line.item)
                    return {
                        ...line,
                        item_id: line.item.id,
                        measure_unit_id: line.measure_unit.id,
                        tax_id: line.tax.id,
                    }
                }),
            }
        },
        fetchPurcahseOrder() {
            this.dataLoading = true;
            this.findByID(this.id).then(response => {
                this.data = this.formatData(response.data)
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({text: message, color: "error"})
            }).finally(() => {
                this.dataLoading = false;
            })
        },
        handleDiscard() {
            this.alert = {...this.alert, value: true, content:"Changes will be discarded. Are you sure?", callback: this.discard }
        },
        discard() {
            this.$router.back()
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.fetchPurcahseOrder();
    },
    beforeRouteUpdate(to, from, next) {
        this.$refs.orderform.resetLines()
        this.id = to.params.id;
        this.fetchPurcahseOrder();
        next();
    }
}
</script>

<style>

</style>